import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";

import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate, Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { BarChart, Bar, Rectangle, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend, } from 'recharts';

export default function OrdersByMonth() {
    const { user } = useAuthContext();
    const [ordersByMonth, setOrdersByMonth] = useState();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();

    var currentDate = new Date();
    console.log("current date", currentDate.getMonth());


    useEffect(() => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/stats/ordersbymonth`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    console.log("response:", res.data);
                    setOrdersByMonth(res.data);
                }
            })
    }, [])

    useEffect(() => {
        if (!ordersByMonth) return;

        const monthNames = [
            "January", "February", "March", "April",
            "May", "June", "July", "August",
            "September", "October", "November", "December"
        ];

        const chartData = ordersByMonth.map((item) => ({
            name: `${monthNames[item.month - 1]}`,
            Orders: item.netContribution,
            fill:
                item.month === (new Date().getMonth() + 1) &&
                    item.year === new Date().getFullYear()
                    ? "#FD64C3"
                    : "#A6A6A6"
        }));

        setData(chartData);

    }, [ordersByMonth]);



    return (
        <div style={{ width: '100%', height: '400px' }}>
            <ResponsiveContainer>
                <BarChart data={data}>
                    <Bar type="monotone"
                        dataKey="Orders"

                    />

                    <CartesianGrid strokeDasharray="5" vertical={false} />

                    <XAxis dataKey="name" />
                    <YAxis />
                </BarChart>
            </ResponsiveContainer>

        </div>
    )
}
